// extracted by mini-css-extract-plugin
module.exports = {"active":"TableRow_active__1ZG3J"};